import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface HeroHfsTwoFlexIntegrityProps {
    items?: CuratedStory[];
}

export default function integrityCheck({
    items = [],
}: HeroHfsTwoFlexIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["image"]);
}
